import React, { Component } from 'react';
//import logo from 'sinwifi.png'
import GetMusic from './getMusic';
class getTimerConexion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conexionDisponible: true,
      conexionLenta: false,
      url_global:props.url_global,
      sw:0
    };
  }

  componentDidMount() {
    console.log("------------>")
    this.verificarConexion(); // Verificar la conexión inmediatamente al montar el componente

    // Establecer un intervalo para verificar la conexión cada 10 segundos (ajusta según tus necesidades)
    this.intervaloConexion = setInterval(this.verificarConexion, 1000);
  }

  componentWillUnmount() {
    // Limpiar el intervalo al desmontar el componente
    clearInterval(this.intervaloConexion);
  }

  verificarConexion = async () => {
    try {
      const tiempoInicio = performance.now();

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Tiempo de espera excedido')), 3000)
      );

      // Realizar una solicitud a la dirección IP 192.168.100.2 (o cualquier URL de tu intranet)
      //await fetch(this.state.url_global+`webservices?timestamp=${Date.now()}`);
      const respuesta = await Promise.race([
        fetch(this.state.url_global+`webservices?timestamp=${Date.now()}`),
        timeoutPromise, // Rechazar la promesa después de 3 segundos si la solicitud no se completa
      ]);


      const tiempoFin = performance.now();
      const duracionSolicitud = tiempoFin - tiempoInicio;

      // Si la solicitud tarda más de cierto tiempo, consideramos que la conexión es lenta
      const tiempoLimiteLento = 2000; // Tiempo límite para considerar la conexión como lenta en milisegundos
      const esLenta = duracionSolicitud > tiempoLimiteLento;

      // Establecer el estado de conexión lenta
      this.setState({ conexionLenta: esLenta,conexionDisponible: true });

      // Si no es lenta, también consideramos que la conexión está disponible
      if (!esLenta) {
        this.setState({ conexionDisponible: true });
      }
    } catch (error) {
      // Manejar cualquier error que pueda ocurrir durante la solicitud
      this.setState({ conexionDisponible: false, conexionLenta: true });
    }
  };

  render() {
    const { conexionDisponible, conexionLenta } = this.state;
    let modulo
    if (conexionDisponible) {
      console.log("La conexión a la intranet está disponible.");
    } else {
      console.log("Se ha perdido la conexión a la intranet.");
      modulo=<div id="loader" style={{"zIndex":"9999999","backgroundColor":"rgba(255,0,0,0.50)"}} className="loader_msg_notificacion is-active" data-text=""><div style={{"width":"100%","height":"100%","textAlign":"center","display":"flex","justifyContent":"center","alignItems":"center","position":"relative"}}> 
          <img src={"sinwifi.png"} alt="Logo" style={{"width":"30%","maxWidth":"100%","maxHeight":"100%"}} />
          <div style={{"position":"absolute","backgroundColor":"rgba(255, 0, 0, 0.9)","padding":"10px","borderRadius":"5px"}}>NO HAY CONEXIÓN</div>
        </div> <GetMusic/></div>
    }

    if (conexionLenta) {
      //console.log("La conexión a la intranet es lenta.");
    }

    return (
      <div>
        {modulo}
      </div>
    );
  }
}

export default getTimerConexion;